import { useObjectStore } from '~/stores/objectStore'

export default defineNuxtRouteMiddleware(async (to) => {
	const adrcd = (to.query.adrcd as string) || (to.params.ADRCD as string)

	if (!adrcd) {
		console.warn(`No adrcd found in route ${to.path}`)
		return navigateTo('/address')
	}

	const objectStore = useObjectStore()

	try {
		await objectStore.fetchObjectData(adrcd)
	} catch (error) {
		switch (objectStore.error) {
			case 'Address not found':
				return showError({
					statusCode: 404,
					statusMessage: 'Details zur angegebenen Adresse konnten nicht gefunden werden. ',
				})
			case 'Invalid address code':
				return showError({
					statusCode: 400,
					statusMessage: 'Ungültiger Adresscode',
				})
			case 'Server error':
				return showError({
					statusCode: 500,
					statusMessage: 'Ein Serverfehler ist aufgetreten',
				})
			default:
				return showError({
					statusCode: 500,
					statusMessage: 'Ein Fehler ist beim Laden der Adressdaten aufgetreten',
				})
		}
	}
})
